<template>
  <div
    class="calico-progressbar-step"
    :style="{ width: line && '100%' }"
  >
    <div
      v-if="line"
      class="line"
    >
      <span :class="{ complete, active }" />
    </div>
    <i
      v-if="active"
      class="icon--xsmall active bi bi-circle-fill"
    />
    <i
      v-else-if="complete"
      class="icon--xsmall bi bi-check-circle-fill"
    />
    <i
      v-else
      class="icon--xsmall bi bi-circle-fill"
    />
  </div>
</template>

<script lang="js">
export default {
  name: 'CalicoProgressbarStep',
  props: {
    line: {
      type: Boolean,
      default: true
    },
    active: {
      type: Boolean,
      default: false
    },
    complete: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.calico-progressbar-step {
  @include inline-space($space-none);
  height: fit-content;
  align-items: center;
  .line {
    flex: 1;
    span {
      display: flex;
      height: 3px;
      flex: 1;
      background: $color-neutral-light;
    }
    .active {
      background: $color-black;
    }
    .complete {
      background: $color-black;
    }
  }
  .active {
    color: $color-black !important;
  }
  .bi-circle-fill {
    color: $color-neutral-light;
  }
  .bi-check-circle-fill {
    color: $color-semantics-success;
  }
}
</style>
